export default "__VITE_ASSET__CCsNB0wm__"